import { jsx as e } from "@emotion/react/jsx-runtime";
import { Stack as t } from "@inflearn/ds-react";
import { p as n } from "./StickyHeaderSkeleton-5da2c20f.mjs";
function m({
  styles: r
}) {
  return /* @__PURE__ */ e(t, { w: "100%", align: "center", children: /* @__PURE__ */ e(n, { styles: r, isAntMan: !1 }) });
}
export {
  m as S
};
